import { render } from "./Contenedor2.vue?vue&type=template&id=331e15cc&scoped=true"
const script = {}

import "./Contenedor2.vue?vue&type=style&index=0&id=331e15cc&scoped=true&lang=css"

import exportComponent from "/Users/bencorp/Desktop/proyectos/Fitbar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-331e15cc"]])

export default __exports__